module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.84cf469.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard2/assest/font/notosanskr/notokr-bold.woff
// module id = uDEH
// module chunks = 0